var __rspack_ns_object = JSON.parse('{"rE":"3.13.0-beta.123"}')